export const isSmallScreen = () => window.matchMedia("(max-width: 768px)").matches;
export const isIpadScreen = () => window.matchMedia("(max-width: 1280px)").matches;
